"use strict";
var gameField = document.querySelector("tbody");
var gameScore = document.querySelector(".game-score");
var button = document.querySelector(".button");
var messageLose = document.querySelector(".message-lose");
var messageWin = document.querySelector(".message-win");
var messageStart = document.querySelector(".message-start");
var cellsInRow = 4;
var scoreCount = 0;
var field;
function startGame() {
    field = Array.from({
        length: cellsInRow
    }, function() {
        return Array(cellsInRow).fill(0);
    });
    scoreCount = 0;
    gameScore.innerText = scoreCount;
    placeTile();
    placeTile();
}
function placeTile() {
    if (!hasEmptyCells()) return;
    var randomRow, randomColumn;
    do {
        randomRow = Math.floor(Math.random() * cellsInRow);
        randomColumn = Math.floor(Math.random() * cellsInRow);
    }while (field[randomRow][randomColumn] !== 0);
    field[randomRow][randomColumn] = Math.random() < 0.8 ? 2 : 4;
    setCells();
}
function hasEmptyCells() {
    return field.some(function(row) {
        return row.includes(0);
    });
}
function removeEmptyCells(row) {
    return row.filter(function(num) {
        return num !== 0;
    });
}
function setCells() {
    for(var i = 0; i < cellsInRow; i++)for(var j = 0; j < cellsInRow; j++){
        var currentCell = gameField.rows[i].cells[j];
        var num = field[i][j];
        currentCell.innerText = "";
        currentCell.classList.value = "";
        currentCell.classList.add("field-cell");
        if (num > 0) {
            currentCell.innerText = num;
            currentCell.classList.add("field-cell--".concat(num));
        }
        if (num === 2048) {
            messageWin.classList.remove("hidden");
            button.classList.replace("restart", "start");
        }
    }
    if (gameIsLost()) messageLose.classList.remove("hidden");
}
function gameIsLost() {
    if (hasEmptyCells()) return false;
    for(var i = 0; i < cellsInRow; i++)for(var j = 0; j < cellsInRow; j++){
        if (field[i][j] === field[i][j + 1]) return false;
    }
    for(var i1 = 0; i1 < cellsInRow - 1; i1++)for(var j1 = 0; j1 < cellsInRow; j1++){
        if (field[i1][j1] === field[i1 + 1][j1]) return false;
    }
    return true;
}
function slide(row) {
    var emptyCell = hasEmptyCells();
    var merge = false;
    for(var i = 0; i < row.length - 1; i++)if (row[i] === row[i + 1]) {
        merge = true;
        break;
    }
    if (!emptyCell && !merge) return row;
    var newRow = removeEmptyCells(row);
    for(var i1 = 0; i1 < newRow.length - 1; i1++)if (newRow[i1] === newRow[i1 + 1]) {
        newRow[i1] *= 2;
        newRow[i1 + 1] = 0;
        scoreCount += newRow[i1];
        gameScore.innerText = scoreCount;
    }
    newRow = removeEmptyCells(newRow);
    while(newRow.length < cellsInRow)newRow.push(0);
    return newRow;
}
function slideLeft() {
    for(var i = 0; i < cellsInRow; i++){
        var row = field[i];
        row = slide(row);
        field[i] = row;
    }
}
function slideRight() {
    for(var i = 0; i < cellsInRow; i++){
        var row = field[i].reverse();
        row = slide(row).reverse();
        field[i] = row;
    }
}
function slideUp() {
    for(var i = 0; i < cellsInRow; i++){
        var col = [
            field[0][i],
            field[1][i],
            field[2][i],
            field[3][i]
        ];
        col = slide(col);
        for(var j = 0; j < cellsInRow; j++)field[j][i] = col[j];
    }
}
function slideDown() {
    for(var i = 0; i < cellsInRow; i++){
        var col = [
            field[0][i],
            field[1][i],
            field[2][i],
            field[3][i]
        ].reverse();
        col = slide(col).reverse();
        for(var j = 0; j < cellsInRow; j++)field[j][i] = col[j];
    }
}
button.addEventListener("click", function() {
    button.classList.replace("start", "restart");
    button.innerText = "Restart";
    messageStart.classList.add("hidden");
    messageLose.classList.add("hidden");
    messageWin.classList.add("hidden");
    startGame();
});
document.addEventListener("keyup", function(e) {
    e.preventDefault();
    var previousField = JSON.stringify(field);
    switch(e.code){
        case "ArrowLeft":
            slideLeft();
            if (JSON.stringify(field) !== previousField) placeTile();
            break;
        case "ArrowRight":
            slideRight();
            if (JSON.stringify(field) !== previousField) placeTile();
            break;
        case "ArrowUp":
            slideUp();
            if (JSON.stringify(field) !== previousField) placeTile();
            break;
        case "ArrowDown":
            slideDown();
            if (JSON.stringify(field) !== previousField) placeTile();
            break;
        default:
            break;
    }
    setCells();
});

//# sourceMappingURL=index.46d9933b.js.map
